/**
 * Teléfono → E.164 de EE.UU. (`+1XXXXXXXXXX`), o null.
 *
 * POR QUÉ MIRA EL CRUDO Y NO SOLO LOS DÍGITOS: si el original trae '+', el
 * prefijo de país es EXPLÍCITO y no se puede reinterpretar. '+1214694523' —una
 * forma real en prod— tiene nueve dígitos de número tras el +1; pelando los
 * dígitos quedan diez y parece un número local perfectamente válido. Aceptarlo
 * produciría '+11214694523' y le acreditaría los puntos a un desconocido.
 *
 * POR QUÉ RECHAZA EN VEZ DE ADIVINAR: el teléfono es la llave de identidad del
 * pase y de la cuenta de puntos. Un número mal normalizado no falla ruidosamente
 * — funciona, sobre la persona equivocada. Prod tiene 25 filas sucias de 2.940
 * (99,1% ya limpio): el costo de rechazar es despreciable.
 *
 * Solo EE.UU. a propósito: los 72 locales son de Texas y alrededores. Un +58 es
 * dato malo, no un cliente internacional.
 *
 * ⚠️ Esta regla existe DOS veces: aquí y en `wallet_normalize_phone` (SQL,
 * migración 20260826151233). Hay un test pgTAP que las amarra sobre los mismos
 * casos. Si cambias una, cambia la otra o el trigger dejará de matchear.
 */
export function normalizePhone(raw: string | null | undefined): string | null {
  if (!raw) return null
  const trimmed = String(raw).trim()
  const digits = trimmed.replace(/[^\d]/g, "")

  if (trimmed.startsWith("+")) {
    return digits.length === 11 && digits.startsWith("1") ? `+${digits}` : null
  }
  if (digits.length === 10) return `+1${digits}`
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`
  return null
}

/**
 * Teléfonos internos: staff y pruebas. Se detectan con
 *   SELECT customer_phone FROM orders
 *   WHERE created_at > now() - interval '90 days'
 *   GROUP BY 1 HAVING COUNT(DISTINCT location_id) >= 4
 * porque un comensal real no compra en 14 locales en 90 días. Hoy son tres.
 *
 * No mueven los agregados (0,7% de las órdenes) pero destruyen cualquier ranking
 * por cliente: el mayor lleva 151 órdenes contra 19 del primer cliente real.
 */
export function isExcludedPhone(phone: string, excluded: ReadonlySet<string>): boolean {
  return excluded.has(phone)
}
